import MasterCrudPage from '../../components/MasterCrudPage';

export default function DailyRates() {
  return (
    <MasterCrudPage
      config={{
        title: 'Daily Rate',
        apiBase: '/payroll/masters/daily-rates',
        listKey: 'dailyRates',
        entityKey: 'dailyRate',
        fields: [{ key: 'rate', label: 'Rate', type: 'number', required: true }],
      }}
    />
  );
}
